/**
 * WSA Switch Manager
 * Persists toggle preferences per customer via localStorage.
 * Storage key: wsa-prefs-{customerId}
 * Data format:  { "blockId": true|false, ... }
 */
class WsaSwitchManager {
  constructor(container) {
    this.container = container;
    this.customerId = container.dataset.customerId || 'guest';
    this.customerEmail = container.dataset.customerEmail || '';
    this.storageKey = `wsa-prefs-${this.customerId}`;
    this.prefs = this.load();

    this.init();
  }

  /**
   * Load saved preferences from localStorage.
   * Returns an empty object if nothing is stored or JSON is invalid.
   */
  load() {
    try {
      const raw = localStorage.getItem(this.storageKey);
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }

  /**
   * Persist current preferences to localStorage.
   */
  save() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.prefs));
    } catch (e) {
      console.warn('[WSA] Could not save preferences:', e);
    }
  }

  /**
   * Sync a specific preference to Klaviyo.
   * Maps block IDs to custom Klaviyo properties.
   */
  syncWithKlaviyo(id, value) {
    const mapping = {
      'wsa_toggle_9HKz38': 'wishlist_price_drop_alerts', // Price drop
      'wsa_toggle_gNkYXy': 'wishlist_inventory_alerts'  // Low stock / Activity
    };

    const propName = mapping[id];
    if (!propName) return;

    window._learnq = window._learnq || [];

    const properties = {
      [propName]: value
    };

    // If we have an email, include it for better identification.
    if (this.customerEmail) {
      properties['$email'] = this.customerEmail;
    }

    try {
      window._learnq.push(['identify', properties]);
      console.log(`[WSA] Synced ${propName}=${value} to Klaviyo`);
    } catch (e) {
      console.warn('[WSA] Klaviyo sync failed:', e);
    }
  }

  /**
   * Apply saved preferences to all checkboxes, then attach change listeners.
   */
  init() {
    const inputs = this.container.querySelectorAll('input[type="checkbox"][data-block-id]');

    inputs.forEach((input) => {
      const id = input.dataset.blockId;

      // Restore saved state if available; otherwise keep the Liquid default.
      if (id in this.prefs) {
        input.checked = this.prefs[id];
      }

      // Listen for user changes.
      input.addEventListener('change', () => {
        const isChecked = input.checked;
        this.prefs[id] = isChecked;
        this.save();
        this.syncWithKlaviyo(id, isChecked);
      });
    });
  }
}

// Initialise all instances on the page (supports multiple sections).
document.querySelectorAll('[data-wsa-toggles]').forEach((el) => {
  new WsaSwitchManager(el);
});
